import styled from 'styled-components';

export const SlideMobileModalHeaderStyled = styled.div`
    &.sticky-top {
        position: sticky;
        top: 0px;
    }
    span {
        font-size: 16px;
        line-height: 34px;
    }
    .close {
        float: right;
        padding: 12px;
        margin-top: -8px;
        margin-right: -8px;

        svg {
            fill: var(--color-label-secondary);
        }
    }
`;

export const SlideMobileModalBoxStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 16px 0;
    background: var(--color-fill-transparent-solid);
    border-radius: 16px;
    box-shadow: var(--shadow-primary);
    .flex-column {
        flex-direction: column;
    }
`;

export const SlideMobileModalInfoRowStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--color-divider-transparent);
    font-weight: 400;
    font-size: 14px;
    padding: 16px 0;

    &.br0 {
        border-radius: 0px;
    }

    .label {
        color: var(--color-label-secondary);
    }

    .price {
        color: var(--color-label-primary);
    }

    .big_price {
        color: var(--color-label-primary);
        font-size: 20px;
        line-height: 28px;
    }

    &.no-border {
        border: none;
    }

    &.brdr-bottom {
        border-bottom: 1px solid var(--color-base-secondary);
        border-top: none;
    }
    &.px-10 {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const SlideMobileAssetInfoStyled = styled.div`
    display: flex;
    gap: 12px;
    background-color: var(--color-button-secondary-default);
    padding: 4px 8px 4px 4px;
    border-radius: 12px;
    align-items: center;
`;

export const SlideMobileAssetInfoSymbolStyled = styled.div`
    display: flex;
    align-items: center;
`;
